<template>
	<div>
		<el-card>
			<div slot="header" class="flex-align-center">
			</div>
			<el-table ref="multipleTable" :data="communityList" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="id" label="ID" width="50">
				</el-table-column>
				<el-table-column align="center" label="封面" prop="cover_image">
					<el-image slot-scope="scope" style="width: 80px; height: 80px" :src="scope.row.cover_image">
					</el-image>
				</el-table-column>
				<el-table-column width="100" prop="userInfo.nickname" label="圈主">
				</el-table-column>
				<el-table-column prop="topic_name" label="圈子名称">
				</el-table-column>
				<el-table-column prop="user_count" label="用户数" align="center">
				</el-table-column>
				<el-table-column prop="post_count" label="帖子数" align="center">
				</el-table-column>
				<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="status" label="首页推荐" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tooltip :content="'推荐/不推荐'" placement="top">
							<el-switch active-color="#13ce66" inactive-color="#999" :active-value="1"
								:inactive-value="0" v-model="scope.row.top_type"
								@change="changeTop(scope.row.id,scope.row.top_type)">
							</el-switch>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tooltip :content="'正常/禁用'" placement="top">
							<el-switch active-color="#13ce66" inactive-color="#999" :active-value="1"
								:inactive-value="0" v-model="scope.row.status"
								@change="changeStatus(scope.row.id,scope.row.status)">
							</el-switch>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column align="center" label="管理" width="200">
					<template slot-scope="scope">
						<el-button @click="topicEdit(scope.row)">编辑</el-button>
						<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消'
							@confirm="topicDel(scope.row.id,scope.$index)" icon="el-icon-info" iconColor="red"
							title="确定删除？">
							<el-button slot="reference" type="danger">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
				layout="total,prev,pager,next" :total="communityLength">
			</el-pagination>
		</el-card>
		<!-- 添加圈子弹窗 -->
		<el-dialog title="创建圈子" :visible.sync="dialogFormVisible">
			<el-form :model="form" ref="form">
				<el-form-item label="">
					<el-select v-model="form.cate_id" placeholder="请选择圈子分类">
						<el-option v-for="item in topicClassList" :key="item.cate_id" :label="item.cate_name"
							:value="item.cate_id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="圈子名称">
					<el-input v-model="form.topic_name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="圈子简介">
					<el-input v-model="form.description" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="圈子封面">
					<el-upload ref="uUpload" class="avatar-uploader" name="Image" :headers="headers" :action="action"
						:on-success="uploadSuccess1" :show-file-list="false">
						<img v-if="form.cover_image" :src="form.cover_image" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="圈子背景">
					<el-upload ref="uUpload" class="avatar-uploader" name="Image" :headers="headers" :action="action"
						:on-success="uploadSuccess2" :show-file-list="false">
						<img v-if="form.bg_image" :src="form.bg_image" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled"
					@click="topicEditSave">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				action: this.$c.domain + "common/upload",
				dialogFormVisible: false,
				currentPage: 1,
				pagesize: 0,
				communityList: [],
				communityLength: 0,
				btnLoading: false,
				btnDisabled: false,
				form: {
					cover_image: "",
					bg_image: ""
				},
				headers: {
					token: this.$store.state.userInfo.token
				},
				topicClassList: []
			}
		},
		created() {
			this.handleCommunityList();
			this.getTopicClass();
		},
		methods: {
			topicEdit(data) {
				this.dialogFormVisible = true;
				this.form = data;
			},
			uploadSuccess1(e) {
				if (e.code == 200) {
					this.form.cover_image = e.result.url;
				}
			},
			uploadSuccess2(e) {
				if (e.code == 200) {
					this.form.bg_image = e.result.url;
				}
			},
			topicEditSave() {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("topic/topicEdit", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.form.introduce = "";
						this.form.img = "";
						this.goodsClassName = "";
						this.$refs.uUpload.clearFiles();
						this.$message.success(res.msg)
						this.handleCommunityList();
						this.dialogFormVisible = false;
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			getTopicClass() {
				this.$H.get("topic/classList").then((res) => {
					this.topicClassList = res.result;
				})
			},
			handleCommunityList() {
				this.$H
					.get("topic/listAll", {
						page: this.currentPage
					})
					.then((res) => {
						this.communityList = res.result.data;
						this.pagesize = res.result.per_page;
						this.communityLength = res.result.total;
					})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.handleCommunityList();
			},
			handleCommand(command) {
				this.handleCommunityList(command.cate_id);
			},
			topicDel(id, index) {
				this.$H.post("topic/topicDel", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.communityList.splice(index, 1);
						this.$message.success('删除成功');
					}
				})
			},
			changeStatus(topicId, status) {
				this.$H.post("topic/saveStatus", {
					id: topicId,
					status: status
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: '状态修改成功',
							type: 'success'
						});
					}
				})
			},
			changeTop(topicId, topType) {
				this.$H.post("topic/saveTop", {
					id: topicId,
					top_type: topType
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: '状态修改成功',
							type: 'success'
						});
					}
				})
			}
		}
	}
</script>

<style>
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	/* 上传 */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
